import { venueRoutes } from '@/Venue/venue.routes';
const venueModule = {
    routes: venueRoutes
};
export default venueModule;
